class FixHeaderPanel {
	constructor($window, $templateCache) {
		this.scope = {
			mainTarget: '@'
		};
		this.restrict = 'A';

		this.$window = $window;
		this.link = this.fixHeaderPanelLink;
		this.$templateCache = $templateCache;
	}

	fixHeaderPanelLink(scope, element, attrs) {
		const $win = angular.element(window);
		const $element = angular.element(element);
		const initialWidth = $element.css('width');
		const $stopFixing = angular.element('#stopFixing');
		const selectionString = '.' + attrs.fixHeaderPanel;

		const remHideClass = () => {
			if ($element.hasClass('hide-scroller-nav')) {
				$element.removeClass('hide-scroller-nav');
			}
		};

		const unFix = () => {
			attrs.fixHeaderToggle = 'false';
			$element.css('width', initialWidth);
			$element.removeClass('make-me-fixed');
		};

		const makeFixed = () => {
			attrs.fixHeaderToggle = 'true';
			$element.addClass('make-me-fixed');
			$element.css('width', angular.element(selectionString).width() + 1);
		};

		$win.on('scroll', () => {
			//if past scroll trigger point
			if ($win.scrollTop() > 450 && attrs.fixHeaderToggle === 'false') {
				makeFixed();
			}
			//if less than scroll trigger point remain absolute
			if ($win.scrollTop() <= 450 && attrs.fixHeaderToggle === 'true') {
				unFix();
			}
			//if near end of container hide the scroller-nav
			if ($win.scrollTop() > $stopFixing.offset().top + $stopFixing.height() - 200) {
				$element.addClass('hide-scroller-nav');
			} else {
				remHideClass();
			}
		});
	}
}

export default /* @ngInject */ ($window, $templateCache) => new FixHeaderPanel($window, $templateCache);